import React from 'react';

const FrogLoader = () => {
  return (
    <div className="fixed inset-0 bg-black z-50 flex flex-col items-center justify-center">
      {/* Title */}
      <h1 className="text-6xl font-black mb-20 text-transparent bg-clip-text bg-gradient-to-r from-green-400 via-emerald-500 to-green-600 animate-pulse">
        WILIN WORLD
      </h1>

      <div className="relative w-[300px] h-[100px]">
        {/* Lily pads with ripple effect */}
        {[...Array(4)].map((_, i) => (
          <div key={i} className="relative">
            <div
              className="absolute w-16 h-16 rounded-full bg-green-900/50"
              style={{
                left: `${i * 80}px`,
                bottom: '0',
                animation: 'float 2s ease-in-out infinite',
                animationDelay: `${i * 0.2}s`
              }}
            >
              <div className="absolute inset-1 rounded-full bg-green-500/30 blur-sm" />
              {/* Ripple effect */}
              <div 
                className="absolute inset-0 rounded-full border-2 border-green-500/20 animate-ping"
                style={{ animationDelay: `${i * 0.2}s` }}
              />
            </div>
          </div>
        ))}
        
        {/* Frog */}
        <div className="absolute w-12 h-12 animate-frog-jump">
          <div className="relative w-full h-full">
            {/* Body */}
            <div className="absolute inset-0 bg-green-500 rounded-full">
              <div className="absolute inset-1 bg-gradient-to-br from-green-400 to-green-600 rounded-full" />
            </div>
            {/* Eyes */}
            <div className="absolute top-1 left-1 w-3 h-3 bg-white rounded-full">
              <div className="absolute inset-1 bg-black rounded-full" />
            </div>
            <div className="absolute top-1 right-1 w-3 h-3 bg-white rounded-full">
              <div className="absolute inset-1 bg-black rounded-full" />
            </div>
          </div>
        </div>

        {/* Loading text */}
        <div className="absolute -bottom-12 left-0 right-0 text-center">
          <span className="inline-block text-green-500 font-bold animate-bounce">
            Loading
            <span className="animate-pulse">...</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default FrogLoader; 